// Pagination
export const EVENTS_TABLE_PAGE_SIZE = 10;

// Accumulation
export const MAX_ACCUMULATED_EVENTS = 500;

// Bulk deletion
export const DELETION_PREVIEW_LIMIT = 40;
export const DELETION_WARNING_THRESHOLD = 50;
export const DELETION_PROGRESS_THRESHOLD = 20;
